<template>
  <div>
    <el-dialog
      title="退车核算规则编辑"
      :visible.sync="dialogVisible"
      @closed="reset"
      width="60%"
    >
      <div class="dialog-body">
        <div class="operation-area">
          <div class="new-take-overtime">
            车辆交接时间：
            <el-date-picker
              v-model="newTakeOverTime"
              :picker-options="pickerOptions"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              @change="handleTakeOverTimeChange"
              style="width: auto"
            >
            </el-date-picker>
          </div>
          <!-- 订单业务类型 10:个人订单 20:企业子订单 -->
          <div class="new-pay-rule" v-if="bizType === 10">
            日租金规则:
            <el-select v-model="localDailyRule" @change="dailyRuleChange">
              <el-option
                v-for="item in dailyRuleOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <QS-common-table
          v-show="settlementData.planInfoPageList.length"
          :data="settlementData.planInfoPageList"
          :columns="columns"
          :pagination="false"
          :border="true"
        >
        </QS-common-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelBtnClick">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!newTakeOverTime"
          @click="handleConfirmBtnClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { previewSettlement } from '@/api/domain/orders'
import { changeReturnCar } from '@/api/domain/cars'
import {
  dailyRuleEnum,
  RETURN_CAR_DAILY_RULE_TYPE_TEXT,
} from '@/config/carManage.js'

export default {
  props: {
    orderId: {
      type: [Number, String],
    },
    takeOverTime: {
      type: String,
    },
    disabledDate: {
      type: String,
    },
    dailyRule: {
      type: Number,
    },
    dailyRuleShow: {
      type: Boolean,
    },
    // 订单业务类型 10:个人订单 20:企业子订单
    bizType: {
      type: Number,
      default: 10,
    },
  },
  data() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    return {
      settlementData: {
        remarks: '',
        planInfoPageList: [],
      },
      newTakeOverTime: '',
      dialogVisible: false,
      columns: [
        {
          name: 'periodNum',
          columnProps: {
            label: '期数',
            prop: 'periodNum',
            width: 120,
          },
        },
        {
          name: 'cycle',
          columnProps: {
            label: '计租周期',
            prop: 'cycle',
            width: 200,
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '应收租金（元）',
            prop: 'receivableAmount',
          },
        },
        {
          name: 'remarks',
          columnProps: {
            label: '收款状态',
            prop: 'remarks',
          },
        },
      ],
      pickerOptions: {
        disabledDate(date) {
          return (
            date.getTime() < moment(_this.disabledDate).valueOf() - 8.64e7 ||
            date.getTime() > Date.now()
          )
        },
      },
      dailyRuleOption: [
        {
          label: RETURN_CAR_DAILY_RULE_TYPE_TEXT[dailyRuleEnum.NATURE_MONTH],
          value: dailyRuleEnum.NATURE_MONTH,
        },
        {
          label: RETURN_CAR_DAILY_RULE_TYPE_TEXT[dailyRuleEnum.THIRTY_DAY],
          value: dailyRuleEnum.THIRTY_DAY,
        },
      ],
      localDailyRule: 0,
    }
  },
  methods: {
    async previewSettlement() {
      previewSettlement({
        orderId: this.orderId,
        takeOverTime: this.newTakeOverTime,
        dailyRule: this.localDailyRule,
      }).then(({ code, data }) => {
        if (code === 1 && data) {
          this.settlementData.remarks = data.remarks || ''
          this.settlementData.planInfoPageList = data.planInfoPageList || []
        }
      })
    },
    handleTakeOverTimeChange(val) {
      this.newTakeOverTime = val
        ? moment(val).format('YYYY-MM-DD HH:mm:ss')
        : ''

      if (val) {
        this.previewSettlement()
      } else {
        this.settlementData.remarks = ''
        this.settlementData.planInfoPageList = []
      }
    },
    reset() {
      this.newTakeOverTime = ''
      this.settlementData.remarks = ''
      this.settlementData.planInfoPageList = []
    },
    handleCancelBtnClick() {
      this.close()
    },
    async handleConfirmBtnClick() {
      changeReturnCar({
        orderId: this.orderId,
        takeOverTime: this.newTakeOverTime,
        originTakeOverTime: this.takeOverTime || '', // 原交接完成时间
        dailyRule: this.localDailyRule,
      }).then(({ code }) => {
        if (code === 1) {
          this.$emit('takeRuleChange', {
            newTakeOverTime: this.newTakeOverTime,
            dailyRule: this.localDailyRule,
          })
          this.close()
        }
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    open() {
      // eslint-disable-line vue/no-unused-properties
      this.dialogVisible = true
      if (this.dailyRuleShow) {
        this.localDailyRule = this.dailyRule
      }
      this.newTakeOverTime = this.takeOverTime
      this.previewSettlement()
    },
    close() {
      this.dialogVisible = false
    },
    // 未足期日车款计算规则change
    dailyRuleChange(val) {
      this.localDailyRule = val
      this.previewSettlement()
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-body {
  padding: 12px 18px;
}
.old-takeovertime {
  margin-bottom: 16px;
  font-weight: bold;
}
.operation-area {
  display: flex;
  justify-content: flex-start;
  .new-take-overtime {
    margin-bottom: 16px;
    font-weight: bold;
    margin-right: 20px;
  }
  .new-pay-rule {
    font-weight: bold;
  }
}
.remarks {
  margin-bottom: 16px;
}
</style>
